import { find } from "lodash";
import React, { memo, useEffect, useState } from "react";
import Select from "react-select";

import { OutlineInputStyles } from "../../globals/styles/select";

const HeaderDropdown = ({
  placeholder = "Search",
  options = [],
  defaultValue = "",
  handleChange,
  clx = "",
  ...rest
}) => {
  const [value, setValue] = useState(null);

  const handleChangeValue = (e) => {
    if (e) {
      setValue(e.value);
      handleChange(e.value);
    } else {
      setValue(null);
      handleChange(undefined);
    }
  };

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return (
    <Select
      classNamePrefix="select"
      isClearable={true}
      options={options}
      styles={OutlineInputStyles(
        {
          control: (base) => ({
            ...base,
            border: 0,
            borderRadius: "0",
            boxShadow: "none",
            backgroundColor: "inherit",
            padding: 0,
            color: "var(--white)",
          }),
          input: (base) => ({
            ...base,
            fontSize: "14px",
            padding: "0",
            color: "var(--white)",
          }),
          placeholder: (base) => ({
            ...base,
            fontSize: "14px",
            color: "var(--white)",
          }),
          singleValue: (base) => ({
            ...base,
            fontSize: "14px",
            color: "var(--white)",
          }),
          dropdownIndicator: (base) => ({
            ...base,
            color: "var(--white)",
            padding: "0 5px",
            "&:hover": {
              color: "rgba(255,255,255,.6)",
            },
          }),
          clearIndicator: (base) => ({
            ...base,
            color: "var(--white)",
            padding: "0 5px",
            "&:hover": {
              color: "rgba(255,255,255,.6)",
            },
          }),
        },
        "100%",
        "14px"
      )}
      placeholder={placeholder}
      onChange={handleChangeValue}
      value={find(options, (item) => item.value === value) || null}
      {...rest}
    />
  );
};

export default memo(HeaderDropdown);
